import theme from 'theme'

const styles = () => ({
  typography: {
    color: theme.palette.primary.contrastText,
  },
  transform: {
    transform: 'translate(-50%, -50%)',
  },
})

export default styles
